import abstractModel from '../../core/MercatelyModel';

const resource = '/api/mia/chatbot/retailer';
const model = abstractModel(resource);

export default model;
